import CompanyProximity from "./CompanyProximity";

export default class Proximity {
  static Company = CompanyProximity;
}
